import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useNavigate, useParams } from 'react-router-dom'
import Select from 'react-select'
import { useDispatch } from 'react-redux'
import { KTIcon } from '../../../../../../_metronic/helpers'
import { AppDispatch } from '../../../../../redux/store'
import {
    createOfferApi,
    getOfferByIdApi,
    updateOfferApi,
} from '../../../../../redux/slices/OfferSlice'
import { toast } from 'react-toastify'
import { right } from '@popperjs/core'
import * as Yup from 'yup';

const OfferForm = () => {
    const { id } = useParams() // Get the ID from the route params
    const dispatch = useDispatch<AppDispatch>()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const validationSchema = Yup.object({
        name: Yup.string().required('Name is required'),
        offer_drive_link: Yup.string().required('Offer drive link is required'),
    });

    // Formik configuration
    const formik = useFormik({
        initialValues: {
            name: '',
            offer_drive_link: '',
            is_active: 0, // New field
        },
        validationSchema,
        onSubmit: async (values) => {
            let data
            if (id) {
                // Update offer API call
                data = await dispatch(updateOfferApi({ id, payload: values }))
            } else {
                // Create new offer API call
                data = await dispatch(createOfferApi(values))
            }

            if (data.payload.success) {
                setLoading(false)
                toast.success(data.payload.reason)
            } else {
                setLoading(false)
                toast.error(data.payload.reason ? data.payload.reason : 'Something went wrong')
            }
            navigate(-1)
        },
    })

    useEffect(() => {
        if (id) {
            fetchOfferData()
        }
    }, [id])

    const fetchOfferData = async () => {
        try {
            const res = await dispatch(getOfferByIdApi(id))
            const offerData = res.payload.data.data
            console.log(offerData) // Log the fetched data
            formik.setValues({
                name: offerData.name || '',
                offer_drive_link: offerData.offer_drive_link || '',
                is_active: offerData.is_active || false,
            })
        } catch (error) {
            toast.error('An error occurred while fetching offer data')
        }
    }


    return (
        <div className='container mt-4'>
            <div className='card shadow' style={{ height: 'auto', minHeight: '500px' }}>
                <form onSubmit={formik.handleSubmit}>
                    {/* Card Header */}
                    <div className='card-header bg-light d-flex justify-content-between align-items-center position-relative py-6'>
                        <h2 className='mb-0'>{id ? 'Edit Offer' : 'Add Offer'}</h2>
                        <button type='submit' className='btn btn-primary'>
                            {id ? 'Update' : 'Submit'}
                        </button>

                        <span
                            className={`position-absolute border-primary`}
                            style={{
                                top: '12px',
                                left: '0',
                                height: '70%',
                                width: '4px',
                                backgroundColor: `var(--bs-primary)`, // Ensures the border color matches the theme
                            }}
                        ></span>
                    </div>

                    {/* Card Body */}
                    <div className='card-body p-6'>
                        <div>
                            <div className='row g-3'>
                                {/* Name */}
                                <div className='col-md-6'>
                                    <label htmlFor='name' className='form-label'>
                                        Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type='text'
                                        id='name'
                                        name='name'
                                        className='form-control'
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        placeholder='Enter offer name'
                                    />
                                    {formik.touched.name && formik.errors.name && (
                                        <div className="text-danger">{formik.errors.name}</div>
                                    )}
                                </div>

                                {/* Status */}
                                <div className="col-md-6">
                                    <label htmlFor="status" className="form-label me-3">
                                    Status
                                    </label>
                                    <select
                                    id="status"
                                    name="status"
                                    className="form-select"
                                    value={formik.values.is_active}
                                    onChange={(e) => {
                                        const value = e.target.value === '1' ? 1 : 0;
                                        formik.setFieldValue('is_active', value);
                                    }}
                                    >
                                    <option value={1}>Active</option>
                                    <option value={0}>Inactive</option>
                                    </select>
                                </div>

                                {/* Points */}
                                <div className="col-md-6">
                                    <label htmlFor="offer_drive_link" className="form-label">
                                    Offer Drive Link <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="offer_drive_link"
                                        name="offer_drive_link"
                                        className="form-control"
                                        value={formik.values.offer_drive_link}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        placeholder="Enter offer drive link"
                                    />
                                    {formik.touched.offer_drive_link && formik.errors.offer_drive_link && (
                                        <div className="text-danger">{formik.errors.offer_drive_link}</div>
                                    )}
                                </div>

                                {/* Is Active */}
                                {/* <div className='col-md-12 pt-6 d-flex align-items-center'>
                                    <input
                                        type='checkbox'
                                        id='is_active'
                                        name='is_active'
                                        className='form-check-input mx-4'
                                        checked={formik.values.is_active}
                                        onChange={(e) => formik.setFieldValue('is_active', e.target.checked)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <label
                                        htmlFor='is_active'
                                        className='form-label me-3 p-0 m-0'
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Is Active
                                    </label>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default OfferForm
